<template>
    <div>
        <div class="page-wrap">
            <h2 class="title-page fw-500">
                <i class="fas fa-book mr-2"></i>เพิ่มข้อมูลบัญชีฝาก
            </h2>
            <div class="body-content">
                <div class="table-content -color-pri">

                    <div class="form-deposit-wrap">
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <label for="name">ชื่อ-นามสกุลบัญชี (ชื่อเรียกบัญชี)</label>
                                <input type="text" v-model="payload.bank_name" class="form-control" />
                            </div>
                            <div class="col-md-6">
                                <label for="name">เลขบัญชี</label>
                                <input type="text" v-model="payload.bank_number" class="form-control" />
                            </div>
                            <div class="col-md-6">
                                <label for="name">เลือกธนาคาร</label>
                                <select v-model="payload.bank_code"
                                    class="browser-default custom-select input-data input-default" name="banktype">
                                    <option disabled value="null" selected>
                                        โปรดเลือกรายการบัญชีธนาคาร
                                    </option>
                                    <option v-for="(data, key) in selectbank" :key="key" :value="key">
                                        {{ data }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="name">วันเดือนปีเกิด</label>
                                <date-picker class="input-date w-100" valueType="format" type="date" lang="en"
                                    v-model="payload.birthday"></date-picker>
                            </div>
                            <div class="col-md-6">
                                <label for="name">เบอร์โทรศัพท์</label>
                                <input type="text" v-model="payload.phone_number" class="form-control" />
                            </div>
                            <div class="col-md-6">
                                <label for="name">รหัสประจำตัวประชาชน</label>
                                <input type="text" v-model="payload.id_card" class="form-control" />
                            </div>
                            <div class="col-md-6">
                                <label for="name">Username</label>
                                <input type="text" v-model="payload.username" class="form-control" />
                            </div>
                            <div class="col-md-6 search-wrapper">
                                <label for="name">Password</label>
                                <div class="input-group">
                                    <input type="password" v-model="payload.password" class="form-control"
                                        id="password" />
                                    <span class="input-group-text" @click="Showpass()">
                                        <i class="far fa-eye" id="togglePassword" style="cursor: pointer"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button type="button" @click="AddAccdeposit()" class="btn btn-search color_white font16"
                                    style="font-weight:400; margin-left:-8px">
                                    บันทึก
                                </button>
                                <button type="button" @click="Clearform()" class="btn btn-cancel color_white font16"
                                    style="font-weight:400;">
                                    เคลีย
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var axios = require("axios");
    import DatePicker from "vue2-datepicker";
    import jwt from "jsonwebtoken";
    import {
        mapGetters,
        mapActions
    } from "vuex";
    export default {
        components: {
            DatePicker,
        },
        data() {
            return {
                activetab: 1,
                activecheck: 1,
                selectbank: [],
                dateselect1: "",
                data: {},
                payload: {
                    bank_name: null,
                    bank_number: null,
                    bank_code: null,
                    birthday: null,
                    phone_number: null,
                    id_card: null,
                    username: null,
                    password: null,
                },
            };
        },
        methods: {
            ...mapActions({
                storeLogin: "login",
                storeLoout: "logout",
                loadsession: "loadsession",
                callApiMotherFucker: "callApiMotherFucker",
            }),
            AddAccdeposit() {
                if (!this.payload.bank_name || this.payload.bank_name == '') {
                    this.Notifyalert("กรุณากรอกชื่อ-นามสกุลบัญชี", "warning")
                } else if (!this.payload.bank_number || this.payload.bank_number.length < 10) {
                    this.Notifyalert("กรุณากรอกเลขบัญชีให้ถูกต้อง", "warning")
                } else if (!this.payload.bank_code || this.payload.bank_code == '') {
                    this.Notifyalert("กรุณาเลือกธนาคาร", "warning")
                } else if (!this.payload.birthday || this.payload.birthday == '') {
                    this.Notifyalert("กรุณาเลือกวันเดือนปีเกิด", "warning")
                } else if (!this.payload.phone_number || this.payload.phone_number.length != 10) {
                    this.Notifyalert("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง", "warning")
                } else if (!this.payload.id_card || this.payload.id_card.length != 13) {
                    this.Notifyalert("กรุณากรอกรหัสประจำตัวประชาชนให้ถูกต้อง", "warning")
                } else if (!this.payload.username || this.payload.username == '') {
                    this.Notifyalert("กรุณากรอก Username", "warning")
                } else if (!this.payload.password || this.payload.password == '') {
                    this.Notifyalert("กรุณากรอก Password", "warning")
                } else {
                    const token = jwt.sign(this.payload, this.$keypayload);
                    var config = {
                        method: "POST",
                        url: "https://sms-fast.warmlight.online/api/addBankDeposit",
                        headers: {
                            Authorization: "Bearer " + this.tokens,
                        },
                        data: {
                            token: token
                        },
                    };
                    axios(config)
                        .then((response) => {
                            if (response.data.code === 0) {
                                this.Notifyalert(response.data.msg, "success")
                            } else {
                                this.Notifyalert(response.data.msg, "warning")
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            },
            Notifyalert(message, icon) {
                this.$swal({
                    text: message,
                    icon: icon,
                    timer: 5000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            },
            Clearform() {
                this.payload.bank_name = null,
                    this.payload.bank_number = null,
                    this.payload.bank_code = null,
                    this.payload.birthday = null,
                    this.payload.phone_number = null,
                    this.payload.id_card = null,
                    this.payload.username = null,
                    this.payload.password = null
            },
            Showpass() {
                const togglePassword = document.querySelector("#togglePassword");
                const password = document.querySelector("#password");
                togglePassword.addEventListener("click", function () {
                    const type = password.getAttribute("type") === "password" ? "text" : "password";
                    password.setAttribute("type", type);
                    this.classList.toggle('fa-eye');
                    this.classList.toggle('fa-eye-slash');
                });
            }
        },
        computed: {
            ...mapGetters({
                isLogin: "isLogin",
                user: "user",
                tokens: "tokens",
            }),
        },
        mounted() {
            this.selectbank = {
                KBANK: "กสิกรไทย จำกัด (มหาชน)",
                SCB: "ไทยพาณิชย์ จำกัด (มหาชน)",
            };
        },
    };
</script>

<style>
.search-wrapper .input-group-text{
        background: #464646 !important;
        color:#fff;
    border-radius: 4px;
}
</style>